import DashboardLayout from 'components/DashboardLayout';
import FormPA from 'components/FormPA';
import FormPaStateProvider from 'components/FormPA/formPaProvider';
import React, { FC } from 'react';
import { RouteComponentProps } from 'react-router';
import { ReviewerViewPaViewModel } from './ReviewerViewPa.ViewModel';

const ReviewerViewPa: FC<RouteComponentProps> = () => {
  const vm = ReviewerViewPaViewModel();

  if (vm.loading) return <div>Loading ...</div>;
  if (!vm.formDetails) return <div>Form details not set ...</div>;

  return (
    <div>
      <FormPaStateProvider formDetails={vm.formDetails} disableInfo disableDetails>
        <DashboardLayout>
          <FormPA />
        </DashboardLayout>
      </FormPaStateProvider>
    </div>
  );
};

export default ReviewerViewPa;
